import { Stack } from "../../../../shared/ui/Stack/Stack";
import { Text } from "../../../../shared/ui/Text/Text";
import styles from "./HeaderMain.module.scss";
import { HeaderPictureMain } from "../HeaderPictureMain/HeaderPictureMain";

import gsap from 'gsap';
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(useGSAP);



export const HeaderMain = () => {

    useGSAP(() => {
        gsap.to('.title', {opacity:1,  ease:"power3.in", duration:2, delay:0});

    }, [])


    return (
        <section>          

                <header className={styles.header}>                      

                        <Stack 
                                justifyContent='justifyCenter'
                                className={styles.titleContainer}>
                            <Text
                                type='h1' 
                                size ='xxxl'
                                className={`title ${styles.title}`}>
                                    ПОЗВОЛЬТЕ СЕБЕ <br/>УЛЫБАТЬСЯ...
                            </Text>                   
                        
                        </Stack>
                        <HeaderPictureMain/>
                </header>
        
        </section>
    );
};